
// import popupMixin from 'common/mixins/popup'

import { computed, nextTick, onMounted, onUnmounted, onUpdated, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex'
import moment from 'moment'
import { callApi } from '@/api/api';
import Spinner from '@/components/transitions/Spinner.vue';
import { position } from 'html2canvas/dist/types/css/property-descriptors/position';


export default {
    emits: ['hide'],
    props: ['showDialog', 'encryptedToken'],
    name: 'DialogRewardsRrecords',
    components: {
        Spinner
    },
    // mixins: [popupMixin],
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    setup(props, { emit }) {
        const store = useStore()
        const route = useRoute()
        const router = useRouter()
        const local = computed(() => store.state.translation.locale)
        const cards = computed(() => store.state.share.records)
        const namesBtnArr = computed(() => store.state.translation.locale.points_details_btn_arr )

        const panel = ref<HTMLElement | null>(null)
        const scrolledCont = ref<HTMLElement | null>(null)
        const listRef = ref<HTMLElement | null>(null)
        const draggingData = reactive({
            startY: 0,
            currentY: 0,
            dragging: false,
            threshold: 300,
            draggingS: false,
            scrollTop_:0
        })

        const namesFilterDate = computed(() => store.state.translation.locale.points_details_filter_arr)

        const data = reactive({
            valuesFilterDate: [3, 6, 12, 24],
            currentFilterVal: route.query.lang?.toString().toLowerCase() == 'en' ? 'Last 3 months' : '最近三个月',
            filteredCards: [] as any[],
        })

        const state = reactive({
            showFilter: false,
            filterDateVal: 3,
            showLoading: false
        })

        watch(
            () => props.showDialog,
            async (newVal, _) => {
                if (newVal && panel.value) {
                    panel.value.style.transform = `translate(-50%,0)`
                    // panel.value.style.transition = 'transform 0.3s ease'
                    openComponent('showLoading')
                    if (props.encryptedToken) {
                        const records = await callApi('/user/points/processes', 'GET', props.encryptedToken as any,route.query.lang?.toString().toLowerCase())
                        .finally(()=>closeComponent('showLoading'))
                        if (records.isSuccess) {
                            await store.dispatch('share/setRecords', records)
                            // console.log(records)
                        } else {
                            await store.dispatch('share/setRecords', {
                                status: false,
                                message: '',
                                isSuccess: false,
                                UserPointsProcessesShare: [],
                                UserPointsProcessesRedeemShare: [],
                                UserPointsProcessesPurchase: [],
                                UserPointsProcessesWithdraw: [],
                                UserPointsProcessesRedeemPurchase: [],
                                UserPointsProcessesPurchasePendding: [],
                                UserPointsProcessesPurchaseRefunded: [],
                                UserPointsProcessesGifts: [],
                                allProcess: []
                            })
                            // router.push(
                            //     {
                            //         path: '/error',
                            //         query: { lang: route.query.lang ?? 'cn' }
                            //     }
                            // )
                        }
                        filterCards()
                    }
                }
            }
        )

        onMounted(async () => {
            document.addEventListener("click", handleClickOutside);
            await store.dispatch(`translation/getLangs`, { userLang: route.query.lang??'cn' })
            filterCards()
        })

        

        onUnmounted(() => {
            document.removeEventListener("click", handleClickOutside);
        })

        function startDragS(e) {
            draggingData.draggingS = true
        }

        function onDragS(e) {
            return 0
        }
        function endDragS() {
            draggingData.draggingS = false
        }

        function startDrag(e) {
            draggingData.dragging = true
            draggingData.startY = e.touches[0].clientY
        }

        function onDrag(e) {
            if (!draggingData.dragging) {
                 return
            }
            if (scrolledCont.value && scrolledCont.value.scrollTop === 0 && draggingData.draggingS || !draggingData.draggingS) {
                draggingData.currentY = e.touches[0].clientY
                const deltaY = draggingData.currentY - draggingData.startY
                if (panel.value && deltaY > 0) {
                    panel.value.style.transform = `translate(-50%,${deltaY}px)`
                }
            }
        }
        function endDrag() {
            const deltaY = draggingData.currentY - draggingData.startY
            if (panel.value && deltaY > draggingData.threshold) {
                panel.value.style.transition = 'transform 0.3s ease'
                panel.value.style.transform = `translate(-50%,${-deltaY + 3000}px)`
                handleHide()
            } else {
                if (panel.value) {
                    panel.value.style.transform = `translate(-50%,0)`
                    panel.value.style.transition = 'transform 0.3s ease'
                }
                setTimeout(() => {
                    if (panel.value)
                        panel.value.style.transition = ''
                }, 300)
            }
            draggingData.dragging = false
        }


        function handleHide() {
            emit('hide')
            draggingData.startY = 0
            draggingData.currentY = 0
            if (panel.value) {
                panel.value.style.transition = ''
            }
        }

        function toggleComponent(name: string) {
            if (name in state) {
                state[name] = !state[name]
            }
        }

        const closeComponent = (name: string) => {
            if (name in state) {
                state[name] = false
            }
        }

        const openComponent = (name: string) => {
            if (name in state) {
                state[name] = true
            }
        }

        const handleClickOutside = (event) => {
            if (listRef.value && state.showFilter && !(listRef.value as any).contains(event.target)) {
                state.showFilter = false;
            }
        }

        const selectVal = (item: any, index: number, filter: string) => {
            state.filterDateVal = item
            data.currentFilterVal = namesFilterDate.value[index]

            filterCards(state.filterDateVal)
        }

        const filterCards = (month = 3) => {
            let arr:any[] = []
            arr = [
                    ...cards.value.UserPointsProcessesGifts.map(element => {return {...element,state:namesBtnArr.value[1],type:local.value.invitation_reward}}),
                    ...cards.value.UserPointsProcessesPurchase.map(element => {return {...element,state:namesBtnArr.value[1],type:selectType(element.user_level,'purchase',element.first_purchase)}}),
                ]
            data.filteredCards = arr.filter((item)=> month >= item.months_category)
            .sort((a,b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()) 
            // console.log('data.filteredCards',data.filteredCards)
        }

        const selectType = (level,type,first_purchase) => {
            if(level === 1) {
                if((type === 'purchase') && first_purchase) return local.value.purchase_level_1
                else if((type === 'purchase') && !first_purchase) return local.value.renwal_level_1
            }else if(level === 2) {
                if((type === 'purchase') && first_purchase) return local.value.purchase_level_2
                else if((type === 'purchase') && !first_purchase) return local.value.renwal_level_2
            }else if(level === 3) {  
                if((type === 'purchase') && first_purchase) return local.value.purchase_level_3
                else if((type === 'purchase') && !first_purchase) return local.value.renwal_level_3
            }else {
                return ''
            }
        }

        const convertDate = (date) => {
            return moment(date).format("YYYY-MM-DD HH:mm")
        }

        return {
            local,
            panel,
            cards,
            scrolledCont,
            startDragS,
            onDragS,
            endDragS,
            startDrag,
            onDrag,
            endDrag,
            emit,
            props,
            handleHide,
            toggleComponent,
            state,
            listRef,
            handleClickOutside,
            data,
            selectVal,
            namesFilterDate,
            convertDate,
            namesBtnArr,
            router
        }
    }
}
